// import logo from './logo.svg';
import './App.css';
import AppRoutes from './routes/AppRoutes';
import { useContext } from 'react';
import UserContext from './contexts/UserContext';
import { useEffect } from 'react';
import AuthRoutes from './routes/AuthRoutes';

function App() {

  const { user, error, getUser } = useContext(UserContext);

  useEffect(() => {
    getUser();
  }, []);

  console.log(error);
  // console.log(user);

  return (
    <>
      {user !== null ? <AppRoutes /> : <AuthRoutes />}
    </>
  );
}

export default App;
